import React from 'react';
import { BsLinkedin, BsGithub, BsInstagram } from 'react-icons/bs';
import { FaXTwitter } from 'react-icons/fa6';
import { HiOutlineDownload } from 'react-icons/hi';

import { Button, OutlineButton } from '../styles/Global.styled.js';
import { useTypewriter } from '../utils/useTypewriter.js';

import {
  HeroSection,
  HeroContent,
  HeroTextBlock,
  HeroGreeting,
  HeroTitle,
  TypewriterWrapper,
  TypewriterGhost,
  TypewriterText,
  Cursor,
  HeroDescription,
  HeroActions,
  SocialLinks,
  SocialIcon,
  HeroImageBlock,
  ImageWrapper,
  HeroGlow,
  FloatingParticle,
  BackgroundGradient,
} from '../styles/Showcase.styled.js';

import ShowcaseImg from '../assets/IMG_2675.jpg';
import ParticleImg from '../assets/particle.png';

const MY_CV_PDF = 'https://arshadkp.online/Arshad-CV-web.pdf';

const HERO_PHRASES = [
  'beautiful digital experiences',
  'scalable mobile applications',
  'intuitive user interfaces',
  'high-performance Flutter apps',
];

const Showcase = () => {
  const typedText = useTypewriter(HERO_PHRASES, {
    typeSpeed: 70,
    deleteSpeed: 35,
    pauseDelay: 2500,
  });

  const longestPhrase = HERO_PHRASES.reduce(
    (longest, phrase) => (phrase.length > longest.length ? phrase : longest),
    ''
  );

  const downloadFile = (url) => {
    const aTag = document.createElement('a');
    aTag.href = url;
    aTag.setAttribute('download', '');
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  };

  return (
    <HeroSection id="Home">
      <BackgroundGradient />

      <HeroContent>
        <HeroTextBlock>
          <HeroGreeting>Hello, I'm Muhammed Arshad</HeroGreeting>

          <HeroTitle>
            I build{' '}
            <TypewriterWrapper>
              <TypewriterGhost aria-hidden="true">{longestPhrase}</TypewriterGhost>
              <TypewriterText>
                {typedText}
                <Cursor />
              </TypewriterText>
            </TypewriterWrapper>
          </HeroTitle>

          <HeroDescription>
            Full Stack Developer specializing in Flutter, React,
            and Node.js, with 5+ years of experience delivering
            complete, scalable, and high-performance applications from
            frontend to backend.
          </HeroDescription>

          <HeroActions>
            <Button onClick={() => downloadFile(MY_CV_PDF)}>
              <HiOutlineDownload size={18} />
              Download CV
            </Button>
            <OutlineButton href="#Projects">View Projects</OutlineButton>
          </HeroActions>

          <SocialLinks>
            <SocialIcon
              href="https://www.linkedin.com/in/muhammed-arshad-628b23193"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <BsLinkedin />
            </SocialIcon>
            <SocialIcon
              href="https://github.com/Muhammed-Arshad"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <BsGithub />
            </SocialIcon>
            <SocialIcon
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaXTwitter />
            </SocialIcon>
            <SocialIcon
              href="https://www.instagram.com/muhd_arshad_/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <BsInstagram />
            </SocialIcon>
          </SocialLinks>
        </HeroTextBlock>

        <HeroImageBlock>
          <HeroGlow />
          <ImageWrapper>
            <img src={ShowcaseImg} alt="Muhammed Arshad" />
          </ImageWrapper>

          <FloatingParticle
            src={ParticleImg}
            alt=""
            top="-20px"
            left="10px"
            duration="7s"
            delay="0s"
          />
          <FloatingParticle
            src={ParticleImg}
            alt=""
            top="40px"
            right="-10px"
            duration="5s"
            delay="1s"
          />
          <FloatingParticle
            src={ParticleImg}
            alt=""
            bottom="20px"
            left="-20px"
            duration="6s"
            delay="2s"
          />
        </HeroImageBlock>
      </HeroContent>
    </HeroSection>
  );
};

export default Showcase;
